import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss']
})
export class TermsPageComponent implements OnInit {

  anchorLocation: string;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.anchorLocation = this.route.snapshot.fragment;
    const element = document.querySelector('#' + this.anchorLocation);
    if (element) element.scrollIntoView(true);
  }
}
